(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Y = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E8DDD5").beginStroke().moveTo(-37.8,167.1).lineTo(-37.8,163.8).curveTo(-27.7,163.8,-19.4,161.3).curveTo(-10.8,158.8,-10.8,149.5).lineTo(-10.8,-9.6).lineTo(-95.8,-146.6).curveTo(-101.9,-156.2,-108.4,-159.9).curveTo(-115.1,-163.9,-125.2,-163.9).lineTo(-125.2,-167.2).lineTo(-45,-167.2).lineTo(-45,-163.9).curveTo(-59.9,-163.9,-66.8,-160.5).curveTo(-73.5,-156.6,-68.8,-148.5).lineTo(11.3,-19).lineTo(86.9,-145).curveTo(92.1,-153.5,85.9,-158.8).curveTo(79.9,-163.9,65.6,-163.9).lineTo(65.6,-167.2).lineTo(125.2,-167.2).lineTo(125.2,-163.9).curveTo(115.3,-164,106.9,-158).curveTo(98.5,-152.3,92.6,-142.8).lineTo(13,-10.3).lineTo(13,149.5).curveTo(13,158.8,21.7,161.3).curveTo(30.2,163.8,40,163.8).lineTo(40,167.1).closePath();
	this.shape.setTransform(125.175,167.15);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Y, new cjs.Rectangle(0,0,250.4,334.3), null);


(lib.txtPerdizes = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E8DDD5").beginStroke().moveTo(349.6,12.8).curveTo(348,12.2,346.8,11.6).curveTo(345.5,10.8,344.6,9.9).lineTo(344.6,13.1).lineTo(344.1,13.1).lineTo(344.1,4.9).lineTo(344.4,4.9).curveTo(345.4,8.6,347.5,10.7).curveTo(349.7,13,353.4,13).curveTo(355.3,13,356.6,12.5).curveTo(358,12.1,358.8,11.3).curveTo(359.7,10.5,360.2,9.3).curveTo(360.4,8.2,360.4,7).curveTo(360.4,5.2,359.4,4.1).curveTo(358,2.9,356.4,2.1).curveTo(354.6,1.2,352.7,0.5).curveTo(350.4,-0.3,348.7,-1.2).curveTo(347,-2.3,345.8,-3.6).curveTo(344.6,-5,344.6,-7).curveTo(344.6,-9.7,346.9,-11.6).curveTo(349.2,-13.3,353.4,-13.3).curveTo(355.5,-13.3,356.8,-12.6).curveTo(358.3,-12.2,359.3,-11.6).curveTo(360.3,-10.8,361.1,-9.7).lineTo(361.1,-13.1).lineTo(361.5,-13.1).lineTo(361.5,-4.9).lineTo(361.2,-4.9).curveTo(360.9,-6.4,360.2,-7.8).curveTo(359.7,-9.3,358.6,-10.4).curveTo(357.9,-11.6,356.5,-12.2).curveTo(355.1,-12.8,353.4,-12.8).curveTo(351.3,-12.8,350.1,-12.3).curveTo(348.9,-11.9,348.1,-11.3).curveTo(347.4,-10.5,347,-9.6).curveTo(346.7,-8.5,346.8,-7.8).curveTo(346.7,-5.8,347.9,-4.7).curveTo(349,-3.3,350.9,-2.4).lineTo(354.7,-0.7).curveTo(356.6,0,358.5,1.1).curveTo(360.1,1.8,361.3,3.2).curveTo(362.4,4.4,362.4,6.3).curveTo(362.5,7.8,362,9.2).curveTo(361.4,10.4,360.2,11.3).curveTo(359.1,12.2,357.4,12.8).curveTo(355.6,13.3,353.4,13.3).curveTo(351.2,13.3,349.6,12.8).closePath().moveTo(243.2,13.1).lineTo(243.2,13).curveTo(244,13,244.5,12.7).curveTo(245.3,12.5,245.3,11.8).lineTo(245.3,4.1).curveTo(245.3,3.4,245.7,2.6).curveTo(245.8,1.8,246.4,0.9).curveTo(247,0.2,247.9,-0.4).curveTo(248.7,-1.1,250.1,-1.5).curveTo(248.7,-1.8,247.9,-2.4).curveTo(247,-3,246.4,-3.8).curveTo(245.8,-4.7,245.7,-5.5).curveTo(245.3,-6.4,245.3,-7).lineTo(245.3,-11.6).curveTo(245.3,-12.3,244.5,-12.6).curveTo(244,-12.8,243.2,-12.8).lineTo(243.2,-13.1).lineTo(258.3,-13.1).lineTo(259.2,-8.7).lineTo(258.9,-8.7).curveTo(258.3,-9.9,258.2,-10.8).lineTo(257.4,-11.9).curveTo(256.9,-12.3,256.3,-12.5).curveTo(255.7,-12.6,254.7,-12.6).lineTo(247.1,-12.6).lineTo(247.1,-7.9).curveTo(247.1,-4.6,248.4,-3.2).curveTo(249.7,-1.7,252.6,-1.7).curveTo(253.1,-1.7,253.4,-1.8).curveTo(253.7,-1.8,253.9,-2.3).lineTo(254.2,-3.5).curveTo(254.3,-4.3,254.3,-5.6).lineTo(254.7,-5.6).lineTo(254.7,5.4).lineTo(254.3,5.4).curveTo(254.3,3.2,254.2,1.8).lineTo(253.9,-0.1).curveTo(253.7,-0.7,253.2,-1.1).curveTo(253.1,-1.2,252.5,-1.2).curveTo(249.6,-1.1,248.4,0.3).curveTo(247.1,1.7,247.1,5).lineTo(247.1,12.7).lineTo(253.2,12.7).curveTo(254.9,12.7,255.8,12.4).curveTo(256.8,12.2,257.4,11.5).curveTo(257.8,10.8,258.3,9.6).lineTo(259.4,6.3).lineTo(259.8,6.3).lineTo(258.5,13.1).closePath().moveTo(142.5,13.1).lineTo(156.1,-12.6).lineTo(147.6,-12.6).curveTo(146.4,-12.6,145.9,-12.5).curveTo(145.3,-12.3,144.9,-11.9).lineTo(144.1,-10.8).lineTo(143.3,-8.7).lineTo(143,-8.7).lineTo(144,-13.1).lineTo(158.6,-13.1).lineTo(145,12.7).lineTo(152.4,12.7).curveTo(154.1,12.7,155.1,12.4).curveTo(155.9,12.2,156.5,11.5).curveTo(157,10.8,157.4,9.6).curveTo(157.9,8.4,158.6,6.3).lineTo(158.9,6.3).lineTo(157.7,13.1).closePath().moveTo(52.3,13.1).lineTo(52.3,13).curveTo(53.1,13,53.6,12.7).curveTo(54.4,12.5,54.4,11.8).lineTo(54.4,-11.7).curveTo(54.4,-12.3,53.6,-12.6).curveTo(53.1,-12.8,52.3,-12.8).lineTo(52.3,-13.1).lineTo(58.4,-13.1).lineTo(58.4,-12.8).lineTo(56.9,-12.6).curveTo(56.1,-12.3,56.1,-11.7).lineTo(56.1,11.8).curveTo(56.1,12.5,56.9,12.7).curveTo(57.6,13,58.4,13).lineTo(58.4,13.1).closePath().moveTo(-54,13.1).lineTo(-54,13).curveTo(-53.3,13,-52.6,12.7).curveTo(-51.9,12.5,-51.9,11.8).lineTo(-51.9,-11.6).curveTo(-51.9,-12.3,-52.6,-12.6).curveTo(-53.3,-12.8,-54,-12.8).lineTo(-54,-13.1).lineTo(-45,-13.1).curveTo(-42.4,-13.1,-40,-12.3).curveTo(-37.5,-11.4,-35.8,-9.7).curveTo(-34,-8.1,-33,-5.6).curveTo(-32,-3.2,-32.1,0).curveTo(-32,3.2,-33,5.5).curveTo(-34,7.9,-35.8,9.8).curveTo(-37.5,11.5,-40,12.2).curveTo(-42.4,13.1,-45,13.1).closePath().moveTo(-50.1,12.7).lineTo(-46.5,12.7).curveTo(-40.3,12.7,-37.2,9.5).curveTo(-34,6.3,-34,0).curveTo(-34,-6.1,-37.4,-9.3).curveTo(-40.4,-12.6,-46.5,-12.6).lineTo(-50.1,-12.6).closePath().moveTo(-144.7,13.1).lineTo(-144.7,13).curveTo(-143.7,13,-143,12.7).curveTo(-142.5,12.4,-143,11.6).lineTo(-151.1,-1.1).curveTo(-153.1,-0.4,-154.2,1.1).curveTo(-155.2,2.5,-155.3,5).lineTo(-155.3,11.8).curveTo(-155.3,12.5,-154.5,12.7).curveTo(-153.8,13,-153.1,13).lineTo(-153.1,13.1).lineTo(-159.2,13.1).lineTo(-159.2,13).curveTo(-158.4,13,-157.9,12.7).curveTo(-157,12.5,-157.1,11.8).lineTo(-157.1,4.1).curveTo(-157.1,3.4,-156.7,2.6).curveTo(-156.4,1.7,-156,0.9).curveTo(-155.4,0.2,-154.5,-0.4).curveTo(-153.6,-1.1,-152.2,-1.5).curveTo(-153.6,-1.8,-154.5,-2.4).curveTo(-155.4,-3,-156,-3.8).lineTo(-156.7,-5.5).curveTo(-157.1,-6.4,-157.1,-7).lineTo(-157.1,-11.6).curveTo(-157,-12.3,-157.9,-12.6).curveTo(-158.4,-12.8,-159.2,-12.8).lineTo(-159.2,-13.1).lineTo(-148.3,-13.1).curveTo(-146.6,-13.1,-145.4,-12.6).curveTo(-144.1,-12.2,-143.2,-11.4).curveTo(-142.3,-10.5,-142,-9.4).curveTo(-141.5,-8.4,-141.5,-7).curveTo(-141.5,-5.8,-142.1,-4.7).curveTo(-142.8,-3.6,-143.7,-2.9).curveTo(-144.6,-2,-145.9,-1.7).curveTo(-147.3,-1.2,-148.7,-1.2).lineTo(-149,-1.2).lineTo(-140.8,11.6).curveTo(-140.1,12.4,-139.7,12.7).curveTo(-139.1,13,-138.3,13).lineTo(-138.3,13.1).closePath().moveTo(-155.3,-7.9).curveTo(-155.3,-4.6,-154,-3.2).curveTo(-152.6,-1.7,-149.6,-1.7).curveTo(-148.4,-1.7,-147.4,-1.8).curveTo(-146.4,-2.3,-145.5,-2.9).curveTo(-144.6,-3.5,-144.1,-4.6).curveTo(-143.7,-5.6,-143.7,-7).curveTo(-143.6,-9.9,-144.8,-11.3).curveTo(-146.1,-12.6,-149,-12.6).lineTo(-155.3,-12.6).closePath().moveTo(-260.1,13.1).lineTo(-260.1,13).curveTo(-259.4,13,-258.8,12.7).curveTo(-258,12.5,-258,11.8).lineTo(-258,4.1).curveTo(-258,3.4,-257.7,2.6).lineTo(-257,0.9).curveTo(-256.3,0.2,-255.4,-0.4).curveTo(-254.5,-1.1,-253.2,-1.5).curveTo(-254.5,-1.8,-255.4,-2.4).curveTo(-256.3,-3,-257,-3.8).lineTo(-257.7,-5.5).curveTo(-258,-6.4,-258,-7).lineTo(-258,-11.6).curveTo(-258,-12.3,-258.8,-12.6).curveTo(-259.4,-12.8,-260.1,-12.8).lineTo(-260.1,-13.1).lineTo(-245.1,-13.1).lineTo(-244,-8.7).lineTo(-244.5,-8.7).lineTo(-245.2,-10.8).curveTo(-245.5,-11.6,-246,-11.9).curveTo(-246.2,-12.3,-247.1,-12.5).curveTo(-247.7,-12.6,-248.5,-12.6).lineTo(-256.2,-12.6).lineTo(-256.2,-7.9).curveTo(-256.2,-4.6,-255,-3.2).curveTo(-253.6,-1.7,-250.7,-1.7).curveTo(-250.2,-1.7,-249.9,-1.8).curveTo(-249.7,-1.8,-249.3,-2.3).lineTo(-249.1,-3.5).curveTo(-249,-4.3,-249,-5.6).lineTo(-248.5,-5.6).lineTo(-248.5,5.4).lineTo(-249,5.4).curveTo(-249,3.2,-249.1,1.8).lineTo(-249.3,-0.1).lineTo(-249.9,-1.1).curveTo(-250.2,-1.2,-250.7,-1.2).curveTo(-253.8,-1.1,-255,0.3).curveTo(-256.2,1.7,-256.2,5).lineTo(-256.2,12.7).lineTo(-249.9,12.7).curveTo(-248.4,12.7,-247.5,12.4).curveTo(-246.4,12.2,-246,11.5).curveTo(-245.5,10.8,-245.1,9.6).lineTo(-244,6.3).lineTo(-243.4,6.3).lineTo(-244.7,13.1).closePath().moveTo(-362.4,13.1).lineTo(-362.4,13).curveTo(-361.7,13,-361.1,12.7).curveTo(-360.3,12.5,-360.4,11.8).lineTo(-360.4,5.4).curveTo(-360.4,4.6,-360,3.7).curveTo(-359.9,2.8,-359.2,2).curveTo(-358.6,1.2,-357.8,0.6).curveTo(-357,0,-355.4,-0.4).curveTo(-357,-0.6,-357.8,-1.2).curveTo(-358.6,-1.8,-359.2,-2.6).curveTo(-359.9,-3.5,-360,-4.4).curveTo(-360.4,-5.2,-360.4,-5.9).lineTo(-360.4,-11.6).curveTo(-360.3,-12.3,-361.1,-12.6).curveTo(-361.7,-12.8,-362.4,-12.8).lineTo(-362.4,-13.1).lineTo(-351,-13.1).curveTo(-349.5,-13.1,-348.1,-12.5).curveTo(-346.9,-12,-346,-11.1).curveTo(-345.3,-10.2,-344.8,-9).curveTo(-344.3,-7.8,-344.3,-6.5).curveTo(-344.3,-5,-345.1,-4).curveTo(-345.6,-2.6,-346.6,-1.8).curveTo(-347.5,-1.1,-348.9,-0.6).curveTo(-350.1,-0.1,-351.5,-0.1).lineTo(-351.9,-0.1).curveTo(-355,-0.1,-356.9,1.4).curveTo(-358.5,2.8,-358.5,6.3).lineTo(-358.5,11.8).curveTo(-358.5,12.5,-357.8,12.7).curveTo(-357.1,13,-356.2,13).lineTo(-356.2,13.1).closePath().moveTo(-358.5,-6.8).curveTo(-358.5,-3.3,-357.3,-2).curveTo(-355.9,-0.6,-353,-0.6).lineTo(-352.6,-0.6).curveTo(-351.3,-0.6,-350.2,-0.9).curveTo(-349.2,-1.2,-348.3,-1.8).curveTo(-347.4,-2.6,-346.9,-3.6).curveTo(-346.5,-4.9,-346.4,-6.5).curveTo(-346.4,-9.3,-347.7,-10.8).curveTo(-348.9,-12.6,-351.8,-12.6).lineTo(-358.5,-12.6).closePath();
	this.shape.setTransform(362.45,13.275);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.txtPerdizes, new cjs.Rectangle(0,0,724.9,26.6), null);


(lib.R = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E8DDD5").beginStroke().moveTo(51.8,167.1).lineTo(51.8,163.8).curveTo(65.5,163.8,72.8,160.7).curveTo(80.2,157.7,74.4,148.2).lineTo(-30.3,-12.6).curveTo(-54.5,-6.4,-68.3,11.9).curveTo(-82.1,30.5,-82.1,63.9).lineTo(-82.1,149.3).curveTo(-82.1,158.8,-73.1,161.2).curveTo(-64.3,163.8,-54.5,163.8).lineTo(-54.5,167.1).lineTo(-132.9,167.1).lineTo(-132.9,163.8).curveTo(-122.9,163.8,-114.5,161.2).curveTo(-105.8,158.8,-105.7,149.3).lineTo(-105.7,53.2).curveTo(-105.7,43.2,-102.6,32.1).curveTo(-99,21.2,-92,11.1).curveTo(-84.7,1.2,-73.1,-6.9).curveTo(-61.6,-15.3,-44.4,-19).curveTo(-61.6,-22.9,-73.1,-31.3).curveTo(-84.7,-39.5,-92,-49.6).curveTo(-99,-59.4,-102.6,-70.3).curveTo(-105.7,-81.3,-105.7,-91.4).lineTo(-105.7,-149.4).curveTo(-105.8,-158.8,-114.5,-161.2).curveTo(-122.9,-163.7,-132.9,-163.6).lineTo(-132.9,-167.2).lineTo(7,-167.2).curveTo(27.6,-167.1,43.7,-161.2).curveTo(59.3,-155.6,70,-145).curveTo(80.9,-134.6,86.5,-121.1).curveTo(91.9,-107.5,91.8,-91.4).curveTo(91.9,-74.3,84.4,-60.6).curveTo(77.1,-46.8,64.7,-36.9).curveTo(52.2,-26.8,35.8,-21.5).curveTo(19.6,-16.3,1.7,-16.3).lineTo(0.8,-16.3).lineTo(-1.8,-16.2).curveTo(-3,-15.7,-4.2,-15.7).lineTo(103,148.2).curveTo(109.3,157.1,115.9,160.5).curveTo(122.8,163.8,132.9,163.8).lineTo(132.9,167.1).closePath().moveTo(-82.1,-101.9).curveTo(-82.1,-58.8,-65.9,-40.2).curveTo(-49.5,-21.6,-11.3,-21.6).lineTo(-10.9,-21.6).curveTo(3.7,-21.7,17.1,-25.1).curveTo(30.5,-29,41.5,-36.9).curveTo(52.2,-45,58.7,-58.1).curveTo(65.5,-71.4,65.5,-91.4).curveTo(65.5,-125.7,49.2,-143.2).curveTo(32.9,-160.9,-1.4,-160.9).lineTo(-82.1,-160.9).closePath();
	this.shape.setTransform(132.9,167.15);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.R, new cjs.Rectangle(0,0,265.8,334.3), null);


(lib.O = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E8DDD5").beginStroke().moveTo(-58.9,157.1).curveTo(-86.1,145.1,-105.9,122.6).curveTo(-125.8,100.2,-136.8,69.3).curveTo(-147.9,38.4,-147.9,0.4).curveTo(-147.9,-37.8,-136.8,-69).curveTo(-125.8,-100.3,-105.9,-122.7).curveTo(-86.1,-145.1,-58.9,-157.1).curveTo(-31.9,-169.3,0.2,-169.3).curveTo(32,-169.3,59,-157.1).curveTo(86.3,-145.1,105.8,-122.7).curveTo(125.8,-100.3,136.9,-69).curveTo(147.9,-37.8,147.9,0.4).curveTo(147.9,38.4,136.9,69.3).curveTo(125.8,100.2,105.8,122.6).curveTo(86.3,145.1,59,157.1).curveTo(32,169.3,0.2,169.3).curveTo(-31.9,169.3,-58.9,157.1).closePath().moveTo(-50.8,-150.7).curveTo(-73.5,-138.3,-89,-116.6).curveTo(-105.1,-94.6,-113.2,-64.6).curveTo(-121.5,-34.3,-121.5,0.4).curveTo(-121.5,35.2,-113.2,65.1).curveTo(-105.1,94.8,-89,116.8).curveTo(-73.5,139.1,-50.8,151.5).curveTo(-28.2,163.8,0.2,163.8).curveTo(28.2,163.8,50.9,151.5).curveTo(73.7,139.1,89.2,116.8).curveTo(105.1,94.8,113.2,65.1).curveTo(121.5,35.2,121.5,0.4).curveTo(121.5,-34.3,113.2,-64.6).curveTo(105.1,-94.6,89.2,-116.6).curveTo(73.7,-138.3,50.9,-150.7).curveTo(28.2,-163,0.2,-163.1).curveTo(-28.2,-163,-50.8,-150.7).closePath();
	this.shape.setTransform(147.9,169.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.O, new cjs.Rectangle(0,0,295.8,338.6), null);


(lib.A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E8DDD5").beginStroke().moveTo(-110.7,159.4).curveTo(-116.2,151.7,-116.3,139.8).curveTo(-116.6,127.9,-113.4,111.9).curveTo(-110.2,95.9,-104.3,76.4).curveTo(-98.3,57,-91.2,35.7).lineTo(-26.5,-168.2).lineTo(-10.6,-168.2).lineTo(89.5,146.2).curveTo(92.1,156,99.5,159.7).curveTo(106.5,162.7,116.4,162.7).lineTo(116.4,166.1).lineTo(40.4,166.1).lineTo(40.4,162.7).curveTo(50,162.7,59,159.8).curveTo(67.9,157.2,64.7,147.8).lineTo(26.3,28.5).curveTo(18.2,31.7,12.1,38.4).curveTo(6.1,45,1.1,53.8).curveTo(-3.9,62.8,-8.2,73.3).curveTo(-12.3,83.7,-16.6,93.8).curveTo(-22.7,107.5,-28.9,120.9).curveTo(-35.3,134.5,-43.7,145).curveTo(-51.8,155.5,-62.9,162).curveTo(-74.1,168.2,-89,168.2).curveTo(-104,168.2,-110.7,159.4).closePath().moveTo(-86.6,41.2).lineTo(-98.5,78.8).curveTo(-104,97,-106.9,111.9).curveTo(-110.2,126.9,-110.2,138.2).curveTo(-110.2,149.6,-105.5,155.5).curveTo(-100.1,162.7,-89,162.7).curveTo(-79.7,162.7,-72.5,156.6).curveTo(-65.8,150.7,-59.9,140.3).curveTo(-54.2,130.1,-48.8,117.4).lineTo(-37.6,91.6).curveTo(-32.3,78.5,-26.5,67.1).curveTo(-21.2,55.5,-13.5,46.2).curveTo(-6.1,36.9,3.2,30.9).curveTo(12.5,25.1,25.2,25.1).lineTo(-28.2,-143.4).closePath();
	this.shape.setTransform(116.3871,168.225);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.A, new cjs.Rectangle(0,0,232.8,336.5), null);


(lib.logoAnima = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_39 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(39).call(this.frame_39).wait(1));

	// perdizes
	this.instance = new lib.txtPerdizes();
	this.instance.setTransform(456.5,432.9,1,1,0,0,0,362.4,13.2);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(25).to({_off:false},0).to({alpha:1},14).wait(1));

	// A
	this.instance_1 = new lib.A();
	this.instance_1.setTransform(418.55,142.15,2.403,2.403,0,0,0,116.4,168.1);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(17).to({_off:false},0).to({regY:168.2,scaleX:1,scaleY:1,x:798.55,y:170.35,alpha:1},8).wait(15));

	// Y
	this.instance_2 = new lib.Y();
	this.instance_2.setTransform(400.4,165.2,2.0863,2.0863,0,0,0,125.2,167.1);
	this.instance_2.alpha = 0;
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(12).to({_off:false},0).to({regY:167.2,scaleX:1,scaleY:1,x:600.35,y:169.35,alpha:1},8).wait(20));

	// O
	this.instance_3 = new lib.O();
	this.instance_3.setTransform(370.7,169.1,2.2053,2.2053,0,0,0,147.9,169.2);
	this.instance_3.alpha = 0;
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(6).to({_off:false},0).to({regY:169.3,scaleX:1,scaleY:1,y:169.3,alpha:1},8).wait(26));

	// R
	this.instance_4 = new lib.R();
	this.instance_4.setTransform(272.65,153.2,2.0529,2.0529,0,0,0,132.8,167.1);
	this.instance_4.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:132.9,regY:167.2,scaleX:1,scaleY:1,x:132.9,y:169.35,alpha:1},9).wait(31));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-261.8,914.9,808.5);


// stage content:
(lib.capa = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		const loadController = () => {
		    if (typeof (window.parent.AllTap) !== 'undefined') {
		        /**
		         *
		         * Class reference.
		         */
		        const
		            AllTapParent = window.parent.AllTap,
		            name_current = 'capa';
		
		        /**
		         *
		         *  @param object
		         *  Set "this", object of canvas CreateJs.
		         */
		        AllTapParent.setState({...AllTapParent.state, [`_this_${name_current}`]: this});
		
		        this.gotoAndStop('frame01');
		
		        createjs.Ticker.removeEventListener('tick', loadController);
		    }
		};
		
		createjs.Ticker.addEventListener('tick', loadController);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1));

	// Background
	this.instance = new lib.logoAnima();
	this.instance.setTransform(1216.2,533.1,1,1,0,0,0,457.4,223.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1304.5,806.5);
// library properties:
lib.properties = {
	id: '0FBEFCCB6FA99240974BF4F7DBA4F13D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFCCFF",
	opacity: 0.00,
	manifest: [],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['0FBEFCCB6FA99240974BF4F7DBA4F13D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
